module.exports = __webpack_public_path__ + "img/vector-2@3x.4a23a2cb.png";